import { render } from "./Welcome.vue?vue&type=template&id=045867d1"
import script from "./Welcome.vue?vue&type=script&lang=ts"
export * from "./Welcome.vue?vue&type=script&lang=ts"
script.render = render

export default script